import guest from "../middleware/guest_middleware";
import auth from "../middleware/auth_middleware";

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunckName: "Login" */ "@/components/auth/Login"),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import(/* webpackChunckName: "Register" */ "@/components/auth/Register"),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import(/* webpackChunckName: "Logout" */ "@/components/auth/Logout"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/forgot_password",
    name: "Forgot_password",
    component: () => import(/* webpackChunckName: "ForgotPassword" */ "@/components/auth/ForgotPassword"),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: "/password/reset/:code",
    name: "Reset_password",
    component: () => import(/* webpackChunckName: "ResetPassword" */ "@/components/auth/ResetPassword"),
    meta: {
      middleware: [guest]
    }
  },
  {
    path: "/verification/success",
    name: "Email_verified",
    component: () => import(/* webpackChunckName: "EmailVerified" */ "@/components/auth/EmailVerified"),
    meta: {
      middleware: [guest]
    }
  },
];